import { inject, Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/env';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import Utils from '../../utils/utils';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LogoutModalComponent } from '../../component/logout-modal/logout-modal.component';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-domain-error',
  templateUrl: './domain-error.component.html',
  standalone: false,
  styleUrl: './domain-error.component.scss'
})
export class DomainErrorComponent {
  public logOutDialogConfig: any = {};
  public util = inject(Utils);
  public dialogModel = inject(MatDialog);
  source: string = '';
  msg: string = '';

  constructor(private router: Router, private route: ActivatedRoute) { }


  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      // Look for the 'source' key
      this.source = params['source'] || 'Unknown';
      if (this.source === 'user') {
        this.msg = `<br/><p style="font-weight:400;font-size:16px;font-family:'Plus Jakarta Sans' !important">We’ve recently made a change to the login process for the Microsoft Certified Trainer (MCT) portal. To improve security and maintain continued access to benefits, MCTs must now use a personal Microsoft account (MSA) to sign in. If you see this pop-up window or error message when trying to log in, it’s likely because you’re using a work or school account (Microsoft Entra ID).<br/><br/><span style="font-weight:700;font-size:16px;font-family:'Plus Jakarta Sans' !important">What you need to do:</span><br/><ul><li><span style="font-weight:400;font-size:16px;font-family:'Plus Jakarta Sans' !important">Use a personal Microsoft account (MSA), such as Outlook.com, Hotmail.com, or Live.com.</span></li><li><span style="font-weight:400;font-size:16px;font-family:'Plus Jakarta Sans' !important"><b>If you are a new applicant</b> enrolling to become an MCT for the first time and don’t have a MSA, you will need to create one. </span></li><li><span style="font-weight:400;font-size:16px;font-family:'Plus Jakarta Sans' !important">To create a personal MSA, go to <a href="https://www.bing.com/ck/a?!&&p=e700325fdeba6ba033ebfb6ca9bf424a831b9e058be8d74bfbe115c069deae63JmltdHM9MTc2MTUyMzIwMA&ptn=3&ver=2&hsh=4&fclid=0e7b7a9f-f934-6725-1e53-6f72f8cc66aa&psq=mcreate+microsoft+account&u=a1aHR0cHM6Ly9zaWdudXAubGl2ZS5jb20vc2lnbnVwP21rdD1lbi11cyZsaWM9MQ" target="_blank">Create your Microsoft account.</a></span></li><li><span style="font-weight:400;font-size:16px;font-family:'Plus Jakarta Sans' !important">Once you have created your MSA, open an in-private browser window and go to <a href="https://aka.ms/mctportal" target="_blank" rel="noopener noreferrer"
     aria-label="the MCT Portal (downloads PDF file, 150KB)">the MCT Portal</a> to sign up using your new MSA. </span></li><li><span style="font-weight:400;font-size:16px;font-family:'Plus Jakarta Sans' !important"><b>If you are an existing MCT</b> renewing your membership, you will need to sign-in using the existing MCT email that you use for your MCT benefits.</span></li></ul><br/><span style="font-weight:400;font-size:16px;font-family:'Plus Jakarta Sans' !important">We appreciate your understanding as we make this transition to ensure a smoother and more secure experience for all MCTs. If you have any questions or need assistance, please reach out to <a href="mailto:mctpvsupport@pearson.com" aria-label="Email MCT Support at mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a></span></p>`;
      }
      else {
        this.msg = `MCTs Admins must use a allowed domains(Pearson.com, Microsoft.com etc) to access the Admin Portal. If you see this pop-up window or error message when trying to log in, it’s likely because you’re using a MSA accounts or restricted Domains.<br/><br/>We appreciate your understanding as we make this transition to ensure a smoother and more secure experience for all MCTs Admins. If you have any questions or need assistance, Please reach out to <a href="mailto:mctpvsupport@pearson.com" aria-label="Email MCT Support at mctpvsupport@pearson.com">mctpvsupport@pearson.com</a>`;
      }
    });


    this.logOutDialogConfig = {
      type: 'logout',
      forComponent: 'logout',
      value: this.msg,
      caseScenario: 3//this.util.checkForSubstring(msg)
    }

    this.dialogModel.open(LogoutModalComponent, {
      autoFocus: '#mct-alert-title', // Directly targets the heading ID
      ariaLabelledBy: 'mct-alert-title',
      ariaDescribedBy: 'mct-alert-description', data: this.logOutDialogConfig, disableClose: true
    });

  }

}
